<template>
    <!-- 标签筛选 -->
    <div class="filterTags" v-show="show">
        <!-- 遮罩层 -->
        <div class="mask" @click="onClickMask"></div>

        <div class="contentBox">
            <ul>
                <li :class="{on: selectTags.length === 0}" @click="onAll">全部</li>
            </ul>
            <ul>
                <li
                    v-for="(item, index)  in tagsData" :key="item.id"
                    :class="{on: selectTags.includes(item.id)}"
                    @click="onTagsSelect(item.id, index)"
                >
                    {{ ellipsis(item.name) }}
                </li>
            </ul>
            <div class="btnBox">
                <a class="reset" href="javascript:void(0)" @click="onReset">重置</a>
                <a class="confirm" href="javascript:void(0)" @click="onConfirm">确定</a>
            </div>
        </div>
    </div>
</template>

<script>
import eventBus, { FILTER_TAGS_SHOW } from '@/utils/eventBus.js'

export default {
    name: 'filterTags',
    props: {
        tagsData: {
            type: Array,
            default () {
                return []
            }
        },
        defaultTagsData: {
            type: Array,
            default () {
                return []
            }
        }
    },
    data () {
        return {
            show: false,
            selectTags: []
        }
    },
    created () {
        eventBus.$on(FILTER_TAGS_SHOW, (bool) => {
            console.log(111)
            this.display(bool)
        })
    },
    methods: {
        ellipsis (value) {
            if (!value) return ''
            if (value.length > 10) {
                return value.slice(0, 10) + '...'
            }
            return value
        },
        /**
         * 全部
         */
        onAll () {
            this.selectTags = []
        },
        /**
         * 控制显示隐藏弹窗
         */
        display (_flag) {
            this.show = _flag
            if (_flag) {
                this.selectTags = JSON.parse(JSON.stringify(this.defaultTagsData))
            }
            this.$emit('filterTagsShow', _flag)
        },
        /**
         * 点击单个标签
         */
        onTagsSelect (_id) {
            if (this.selectTags.includes(_id)) {
                const index = this.selectTags.indexOf(_id)
                this.selectTags.splice(index, 1)
            } else {
                this.selectTags.push(_id)
            }
        },
        /**
         * 重置tags
         */
        onReset () {
            this.selectTags = []
        },
        onClickMask () {
            this.display(false)
        },
        /**
         * 确定
         */
        onConfirm () {
            this.display(false)
            this.$emit('onFilterTagsChange', this.selectTags)
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '../../../assets/stylus/variables'
.filterTags
    position absolute
    width 100%
    box-sizing border-box
    z-index 20
    top 80px
    left 0
    border-top 1px solid #eeeeee
    background #fff
    .contentBox
        padding 30px 20px
        position relative
        z-index 30
        background #fff
        ul
            li
                border-radius 4px
                border 1px solid #eeeeee
                background #eeeeee
                color #666666
                font-size 24px
                line-height 24px
                margin 0 16px 16px 0
                display inline-block
                padding 18px 20px
                border-radius 10px
            .on
                background #ffdede
                border 1px solid #fc2d2d
                color #fc2d2d
    .btnBox
        display flex
        justify-content space-between
        margin-top 10px
        a
            width 336px
            height 82px
            line-height 82px
            border-radius 10px
            font-size 30px
            text-align center
            display inline-block
        .reset
            background #eeeeee
            color #333333
        .confirm
            background-image linear-gradient(270deg, #ff5a00 0%, #feb62b 100%), linear-gradient( #eeeeee, #eeeeee)
            color #333333
    .mask
        background rgba(0,0,0, 0.2)
        width 100%
        height 90vh
        position absolute
        z-index 11
        top 0
        left 0
</style>
